import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { VendorCtaSelectorProps } from './VendorCtaSelector';

const GubagooCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  const { ctaGubagooLabel, flowOptionGubagoo } = ctaDetails;
  return (
    <TextButton
      variant={variant}
      key={`key_${flowOptionGubagoo}`}
      className="cbo-button"
      data-flow={flowOptionGubagoo}
      data-vin={vin}
      data-testid="gubagoo"
      // eslint-disable-next-line no-script-url
      href="javascript:void(0)"
    >
      {ctaGubagooLabel}
    </TextButton>
  );
};

export default GubagooCta;
